var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerOne'),(_vm.isMobile)?[_c('router-view',{class:_vm.$route.name == 'personal' ? '' : 'app-body-pc'})]:[_c('keep-alive',[_c('router-view',{class:_vm.$route.name == 'personal' ? '' : 'app-body-mobile'})],1)],_c('footerOne'),_c('backTop')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }